import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import {
  createFileResource,
  deleteFileResource,
  updateFileResource,
} from "graphql/mutations";
import { listFileResourceSortBySortIndex } from "graphql/queries";
import {
  CreateFileResourceInput,
  DeleteFileResourceInput,
  FileResource,
  ListFileResourceSortBySortIndexQuery,
  ModelSortDirection,
  UpdateFileResourceInput,
} from "types/graphqlapi";

/**
 * 同一案件のインタビューリソースリストを取得
 * @param subjectId
 * @returns
 */
export const fetchFileResourcesBySubjectIdQuery = async (subjectId: string) => {
  const result = (await API.graphql(
    graphqlOperation(listFileResourceSortBySortIndex, {
      subject_id: subjectId,
      sortDirection: ModelSortDirection.ASC,
      limit: 1000,
    })
  )) as {
    data: ListFileResourceSortBySortIndexQuery;
  };

  const list = result.data?.listFileResourceSortBySortIndex
    ?.items as FileResource[];

  // タイトルの昇順でソート
  list &&
    list.sort((a, b) => {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    });

  return list;
};

/**
 * 新規作成
 * @param
 * @returns 作成されたデータ
 */
export const createInterviewResoucesMutation = async (
  createInterviewResoucesInput: CreateFileResourceInput
) => {
  const result = (await API.graphql(
    graphqlOperation(createFileResource, {
      input: createInterviewResoucesInput,
    })
  )) as GraphQLResult<{ created: FileResource }>;

  return result;
};

/**
 * 特定のリソースデータ更新
 * @param updateInterviewResoucesInput
 * @returns
 */
export const updateInterviewResouceMutation = async (
  updateInterviewResoucesInput: UpdateFileResourceInput
) => {
  const result = (await API.graphql(
    graphqlOperation(updateFileResource, {
      input: updateInterviewResoucesInput,
    })
  )) as GraphQLResult<{ created: FileResource }>;

  return result;
};

/**
 * 特定のリソースデータ削除
 * @param
 * @returns 削除されたデータ
 */
export const deleteInterviewResouceMutation = async (
  deleteInterviewResoucesInput: DeleteFileResourceInput
) => {
  const result = (await API.graphql(
    graphqlOperation(deleteFileResource, {
      input: deleteInterviewResoucesInput,
    })
  )) as GraphQLResult<{ deleted: FileResource }>;

  return result.data?.deleted?.id;
};

export const getFileResoucesByFileUrl = async (
  subject_id: string,
  url: string
) => {
  const result = (await API.graphql(
    graphqlOperation(listFileResourceSortBySortIndex, {
      subject_id,
      filter: { url: { eq: url } },
    })
  )) as {
    data: ListFileResourceSortBySortIndexQuery;
  };

  const list = result.data?.listFileResourceSortBySortIndex
    ?.items as FileResource[];

  if (list.length >= 1) {
    return list[0];
  } else {
    return undefined;
  }
};
